module.exports = __webpack_public_path__ + "static/media/circle-small.3a1e0102.png";